import { FormikNumber } from "../../../../../components/FormikFields/FormikNumber.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/cadence/CadenceOccurrenceForm.tsx
function CadenceOccurrenceForm({ name }) {
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
		className: "min-w-0 flex-1",
		children: /* @__PURE__ */ jsx(FormikNumber, {
			hint: "required",
			label: "Cadence",
			min: 1,
			name: `${name}.cadenceMinutes`,
			step: 1,
			subText: "Length of each slot, in minutes. Must be at least 1."
		})
	}), /* @__PURE__ */ jsx("div", {
		className: "min-w-0 flex-1",
		children: /* @__PURE__ */ jsx(FormikNumber, {
			hint: "required",
			label: "Buffer",
			min: 0,
			name: `${name}.bufferMinutes`,
			step: 1,
			subText: "Extra minutes after a slot's end that still count for that slot. 0 is allowed."
		})
	})] });
}
//#endregion
export { CadenceOccurrenceForm };

//# sourceMappingURL=CadenceOccurrenceForm.js.map